import { render, staticRenderFns } from "./tool-btns.vue?vue&type=template&id=7a80c80c&scoped=true"
import script from "./tool-btns.vue?vue&type=script&lang=js"
export * from "./tool-btns.vue?vue&type=script&lang=js"
import style0 from "./tool-btns.vue?vue&type=style&index=0&id=7a80c80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a80c80c",
  null
  
)

export default component.exports